import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ActionMenu = ({ items = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    handleClose();

    if (action) {
      action();
    }
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {items.map((item, index) => (
          <MenuItem
            key={index}
            disabled={item.disabled}
            onClick={() => handleAction(item.onClick)}
          >
            {item.icon && (
              <ListItemIcon
                sx={{
                  color:
                    item.color === "error"
                      ? "error.main"
                      : item.color === "warning"
                        ? "warning.main"
                        : item.color === "success"
                          ? "success.main"
                          : item.color === "primary"
                            ? "primary.main"
                            : "inherit",
                }}
              >
                {item.icon}
              </ListItemIcon>
            )}

            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                color:
                  item.color === "error"
                    ? "error.main"
                    : item.color === "warning"
                      ? "warning.main"
                      : item.color === "success"
                        ? "success.main"
                        : item.color === "primary"
                          ? "primary.main"
                          : "inherit",
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
